export class SocialButton {
  private readonly iconDark: string;
  private readonly iconLight: string;

  constructor(icon: string, public readonly link: string) {
    this.iconLight = `assets/images/${icon}.svg`;
    this.iconDark = `assets/images/${icon}.dark.svg`;
  }
}
